import React, { useState } from 'react';
import { Translate as t } from '../../config/Translate';

const WorkScheduleOverrideEditor = ({ show, onClose, onSave, isLoading }) => {
	const [startDate, setStartDate] = useState('');
	const [endDate, setEndDate] = useState('');
	const [isOff, setIsOff] = useState(false);
	const [timeSlots, setTimeSlots] = useState([{ start: '09:00', end: '18:00', label: '' }]);
	const [reason, setReason] = useState('');

	const handleSave = () => {
		if (!startDate || !endDate || !reason) return;
		if (startDate > endDate) return;
		onSave({
			startDate,
			endDate,
			isOff,
			reason,
			timeSlots: isOff ? [] : timeSlots.filter(s => s.start && s.end),
		});
		resetForm();
	};

	const resetForm = () => {
		setStartDate('');
		setEndDate('');
		setIsOff(false);
		setTimeSlots([{ start: '09:00', end: '18:00', label: '' }]);
		setReason('');
	};

	const handleClose = () => {
		resetForm();
		onClose();
	};

	const addSlot = () => {
		setTimeSlots(prev => [...prev, { start: '09:00', end: '18:00', label: '' }]);
	};

	const removeSlot = (idx) => {
		setTimeSlots(prev => prev.filter((_, i) => i !== idx));
	};

	const updateSlot = (idx, field, value) => {
		setTimeSlots(prev => prev.map((s, i) => i === idx ? { ...s, [field]: value } : s));
	};

	if (!show) return null;

	const dateRangeInvalid = startDate && endDate && startDate > endDate;

	return (
		<div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
			<div className="modal-dialog">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title">{t('user.workSchedule.overrideAdd')}</h5>
						<button type="button" className="btn-close" onClick={handleClose} disabled={isLoading}></button>
					</div>
					<div className="modal-body">
						{/* Start Date */}
						<div className="mb-3">
							<label className="form-label fw-bold">{t('user.workSchedule.startDate')}</label>
							<input
								type="date"
								className="form-control"
								value={startDate}
								onChange={(e) => setStartDate(e.target.value)}
							/>
						</div>

						{/* End Date */}
						<div className="mb-3">
							<label className="form-label fw-bold">{t('user.workSchedule.endDate')}</label>
							<input
								type="date"
								className={`form-control${dateRangeInvalid ? ' is-invalid' : ''}`}
								value={endDate}
								onChange={(e) => setEndDate(e.target.value)}
							/>
							{dateRangeInvalid && (
								<div className="invalid-feedback">{t('user.workSchedule.dateRangeError')}</div>
							)}
						</div>

						{/* Type */}
						<div className="mb-3">
							<label className="form-label fw-bold">{t('user.workSchedule.override')}</label>
							<div className="form-check">
								<input
									className="form-check-input"
									type="radio"
									name="overrideType"
									id="typeChange"
									checked={!isOff}
									onChange={() => setIsOff(false)}
								/>
								<label className="form-check-label" htmlFor="typeChange">
									{t('user.workSchedule.overrideTypeChange')}
								</label>
							</div>
							<div className="form-check">
								<input
									className="form-check-input"
									type="radio"
									name="overrideType"
									id="typeOff"
									checked={isOff}
									onChange={() => setIsOff(true)}
								/>
								<label className="form-check-label" htmlFor="typeOff">
									{t('user.workSchedule.overrideTypeOff')}
								</label>
							</div>
						</div>

						{/* Time Slots (only when not off) */}
						{!isOff && (
							<div className="mb-3">
								<label className="form-label fw-bold">{t('user.workSchedule.timeSlots')}</label>
								{timeSlots.map((slot, idx) => (
									<div key={idx} className="row g-2 mb-2 align-items-center">
										<div className="col-5">
											<input
												type="time"
												className="form-control form-control-sm"
												value={slot.start}
												onChange={(e) => updateSlot(idx, 'start', e.target.value)}
											/>
										</div>
										<div className="col-5">
											<input
												type="time"
												className="form-control form-control-sm"
												value={slot.end}
												onChange={(e) => updateSlot(idx, 'end', e.target.value)}
											/>
										</div>
										<div className="col-2">
											{timeSlots.length > 1 && (
												<button
													type="button"
													className="btn btn-sm btn-outline-danger"
													onClick={() => removeSlot(idx)}
												>
													<ion-icon name="close-outline"></ion-icon>
												</button>
											)}
										</div>
									</div>
								))}
								<button type="button" className="btn btn-sm btn-outline-primary" onClick={addSlot}>
									+ {t('user.workSchedule.addTimeSlot')}
								</button>
							</div>
						)}

						{/* Reason */}
						<div className="mb-3">
							<label className="form-label fw-bold">{t('user.workSchedule.overrideReason')} *</label>
							<input
								type="text"
								className="form-control"
								value={reason}
								onChange={(e) => setReason(e.target.value)}
								placeholder={t('user.workSchedule.overrideReason')}
							/>
						</div>
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-secondary btn-sm" onClick={handleClose} disabled={isLoading}>
							{t('common.button.cancel')}
						</button>
						<button
							type="button"
							className="btn btn-primary btn-sm"
							onClick={handleSave}
							disabled={isLoading || !startDate || !endDate || !reason || startDate > endDate}
						>
							{isLoading ? t('service.issueManager.processing') : t('common.button.save')}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default WorkScheduleOverrideEditor;
